// Wrapper de Plotly reactivo, con el tema claro de la aplicación.
// Los colores salen de la misma paleta que la interfaz (tailwind.config.js /
// index.css) para que un gráfico no parezca de otra aplicación.
import Plot from "react-plotly.js";
import type { Data, Layout } from "plotly.js-dist-min";

export const COLORWAY = [
  "#2a78d6", // marca
  "#ec835a", // estado-serio
  "#0ca30c", // estado-ok
  "#8a63d2",
  "#fab219", // estado-warning
  "#52514e", // tinta-2
];

// El tipo del eje no se exporta desde el paquete: se deriva del propio Layout.
type Eje = NonNullable<Partial<Layout>["xaxis"]>;

const EJE: Eje = {
  gridcolor: "#e1e0d9",
  zerolinecolor: "#c3c2b7",
  linecolor: "#e1e0d9",
  // Que el eje reserve el sitio que necesitan SUS etiquetas, en vez de confiar en
  // un margen fijo: en una pantalla estrecha, un margen pensado para escritorio se
  // come la mitad del gráfico y recorta las barras.
  automargin: true,
};

const temaClaro: Partial<Layout> = {
  paper_bgcolor: "#fcfcfb",
  plot_bgcolor: "#fcfcfb",
  font: { color: "#52514e", family: "Inter, system-ui, sans-serif" },
  colorway: COLORWAY,
  xaxis: EJE,
  yaxis: EJE,
  margin: { t: 30, r: 20, l: 50, b: 50 },
};

export default function PlotlyChart({ data, layout, style }: {
  data: Data[];
  layout?: Partial<Layout>;
  style?: React.CSSProperties;
}) {
  // Los ejes se fusionan campo a campo: si una página solo define `xaxis.title`,
  // un spread superficial perdería el color de rejilla del tema.
  const merged: Partial<Layout> = {
    ...temaClaro,
    ...layout,
    xaxis: { ...EJE, ...(layout?.xaxis ?? {}) },
    yaxis: { ...EJE, ...(layout?.yaxis ?? {}) },
  };
  return (
    <Plot
      data={data}
      layout={merged as Layout}
      style={{ width: "100%", height: "100%", ...style }}
      config={{
        responsive: true,
        displaylogo: false,
        // La barra de herramientas solo al pasar por encima: en móvil no hay
        // «encima», así que desaparece en vez de taparle el gráfico al usuario.
        displayModeBar: "hover",
      }}
    />
  );
}
